<template>
  <div
    v-if="modelBlog && user.is_admin"
    class="flex flex-wrap items-center gap-x-10 gap-y-4 border rounded-lg p-2 shadow mb-4"
    >
    <ui-switch
      v-model="modelBlog.is_editing"
      text="Edit"
      class="pl-2"
      />
    <ui-switch
      v-model="modelBlog.show_as_object"
      text="Show as object"
      />
    <ui-switch
      v-model="modelBlog.is_internal"
      text="Internal"
      />
    <ui-switch
      v-model="modelBlog.is_listed"
      text="Listed"
      />
    <ui-switch
      v-model="modelBlog.is_system_content"
      text="System content"
      />

    <div class="inline-flex flex-grow items-center justify-end gap-2">
      <ui-button
        class="px-3 !text-sm !border-red-500"
        text="Delete"
        @click="methodDelete"
        />
      <ui-link
        :to="computedBlogUrl"
        @click="methodSave(modelBlog)"
        >
        <blog-button
          class="dark !text-sm"
          text="Show"
          />
      </ui-link>
      <ui-button
        class="dark !text-sm"
        text="Save"
        @click="methodSave(modelBlog)"
        />
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['saved', 'delete']);

const { locale } = useI18n()
const modelBlog = defineModel<Blog | null>('blog');

const methodSave = async (blog: Blog) => {
  await methodSaveBlog(blog)
  emit('saved');
};

const methodDelete = async () => {
  if (!modelBlog.value || !modelBlog.value.id) {
    return notify({
      type: 'error',
      text: 'Blog not found',
    })
  }

  await methodDeleteBlog(modelBlog.value.id as string)

  emit('delete')
}

const computedBlogUrl = computed(() => {
  if(!modelBlog.value) return '';

  const url = modelBlog.value?.meta?.i18n?.[locale.value]?.url ?? modelBlog.value.url;

  return (url)
    ? useLocalePath()(url)
    : useLocalePath()('/blog/'+ modelBlog.value.slug)
})

</script>
